export default __webpack_public_path__ + "static/media/Whatsapp E-mail SMS.4b4242ac.png";